'use client';
import { useQuery } from '@tanstack/react-query';
import Row from 'antd/es/row';
import Col from 'antd/es/col';

import { Container, SearchBar, TourAndCruiseLanding } from '@shared';
import { callService } from '@api/caller';
import Markdown from '@components/utils/Markdown';
import MetaInfo from '@components/views/components/MetaInfo';

const HotelPage = () => {
  const { data } = useQuery(['hotelLanding'], () =>
    callService('SfContentsService', 'getSfHotelLanding')
  );

  const domesticHotels = data?.contentItems?.[0];
  const intHotels = data?.contentItems?.[1];

  return (
    <>
      <MetaInfo
        title='Oteller - Shop & Fly'
        description='Otel rezervasyonundan uçak biletine, araç kiralamadan gemi turlarına, tatil planınızın her adımında Shop & Fly seyahat yanınızda!'
      />
      <TourAndCruiseLanding.Wrapper>
        <SearchBar activeService='hotel' />
        <Container>
          <TourAndCruiseLanding.ContainerItem isBorder>
            <TourAndCruiseLanding.TitleContainer>
              <TourAndCruiseLanding.Title>
                {data?.discountTitle}
              </TourAndCruiseLanding.Title>
            </TourAndCruiseLanding.TitleContainer>
            <TourAndCruiseLanding.DiscountContent text={data?.discountText} />
          </TourAndCruiseLanding.ContainerItem>
          <TourAndCruiseLanding.ContainerItem className='containerItem__header'>
            <Row gutter={[20, 20]}>
              {data?.hotelItems?.map((item) => (
                <Col key={item.title} xs={24} md={12} xl={8}>
                  <TourAndCruiseLanding.Card
                    image={item.image}
                    title={item.title}
                    href={item.href}
                  />
                </Col>
              ))}
            </Row>
          </TourAndCruiseLanding.ContainerItem>
          <TourAndCruiseLanding.ContainerItem className='containerItem__header'>
            <TourAndCruiseLanding.TagLinks
              title={domesticHotels?.title}
              content={domesticHotels?.content}
              items={domesticHotels?.items || []}
            />
          </TourAndCruiseLanding.ContainerItem>
          <TourAndCruiseLanding.ContainerItem className='containerItem__header'>
            <TourAndCruiseLanding.TagLinks
              title={intHotels?.title}
              content={intHotels?.content}
              items={intHotels?.items || []}
            />
          </TourAndCruiseLanding.ContainerItem>
          <TourAndCruiseLanding.ContainerItem className='containerItem__header'>
            <TourAndCruiseLanding.TourContentTitle>
              {data?.reservationTitle}
            </TourAndCruiseLanding.TourContentTitle>
            <TourAndCruiseLanding.TourContent>
              <Markdown text={data?.reservationText} />
            </TourAndCruiseLanding.TourContent>
          </TourAndCruiseLanding.ContainerItem>
        </Container>
      </TourAndCruiseLanding.Wrapper>
    </>
  );
};

export default HotelPage;
